<i18n>
{
  "fr": {
    "title": "Sélection du point relais DPD",
    "relay-modal-submit": "Sélectionner ce point relais",
    "tab-relays-list": "Liste des relais",
    "tab-map": "Carte"
  }
}
</i18n>

<template>
  <CheckoutModal v-model="isModalActive" class="relay-modal">
    <template v-slot:title>
      {{ $t('title') }}
    </template>

    <div class="relay-modal__content">
      <div class="replay-modal__search">
        <AddressInput
          id="relay-modal-search"
          name="relay-modal-search"
          placeholder="Adresse, code postal, ville…"
          icon-before-input
          :on-address-click="onAddressClick"
        />
      </div>

      <ul class="tabs">
        <li
          v-for="tab in [TAB_RELAYS_LIST, TAB_MAP]"
          :key="tab"
          class="tabs__item"
          :class="[
            `tabs__item--${tab}`,
            { 'tabs__item--active': tab === currentTab },
          ]"
          @click="currentTab = tab"
        >
          <button type="button" class="tabs__link">
            {{ $t(`tab-${tab}`) }}
          </button>
        </li>
      </ul>

      <div class="relay-modal__results">
        <template v-if="TAB_MAP === currentTab || $matchMedia.m">
          <RelayMap
            :relays-list="relayArray"
            v-bind="{ activeRelay }"
            @markerClicked="markerClicked"
          />
          <RelayDetail
            v-if="activeRelay"
            :relay="activeRelay"
            no-input
            hours-visible
          />
        </template>

        <ol
          v-if="TAB_RELAYS_LIST === currentTab || $matchMedia.m"
          class="relay-modal__list"
        >
          <li
            v-for="relay in relayArray"
            :key="relay.pudo_id"
            class="relay-modal__list-item"
          >
            <RelayPlaceholder v-if="relay.isPlaceholder" />
            <RelayDetail
              v-else
              :active="isCurrentRelay(relay)"
              v-bind="{ relay }"
              @change="relayClicked(relay)"
            />
          </li>
        </ol>
      </div>
    </div>

    <template v-slot:action-toolbar>
      <div class="relay-modal__submit-btn-wrapper">
        <button
          type="button"
          class="base-btn base-btn--secondary"
          :disabled="!activeRelay"
          @click="confirmRelaySelection"
        >
          {{ $t('relay-modal-submit') }}
        </button>
      </div>
    </template>
  </CheckoutModal>
</template>

<script>
import axios from 'axios';
import CheckoutModal from './CheckoutModal';
import RelayDetail from './RelayDetail.vue';
import RelayMap from './RelayMap.vue';
import RelayPlaceholder from './RelayPlaceholder.vue';
import AddressInput from '../AddressInput.vue';

const TAB_RELAYS_LIST = 'relays-list';
const TAB_MAP = 'map';

const relayPlaceholders = [
  { isPlaceholder: true },
  { isPlaceholder: true },
  { isPlaceholder: true },
  { isPlaceholder: true },
];

export default {
  name: 'RelayModal',
  components: {
    CheckoutModal,
    RelayDetail,
    RelayMap,
    RelayPlaceholder,
    AddressInput,
  },
  props: {
    currentRelay: {
      type: Object,
      default: null,
    },
    address: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      TAB_RELAYS_LIST,
      TAB_MAP,
      activeRelay: null,
      relayArray: relayPlaceholders,
      search: this.address,
      currentTab: TAB_RELAYS_LIST,
    };
  },
  computed: {
    isModalActive: {
      get() {
        return window.modalStateObservable.isRelayModalActive;
      },
      set(v) {
        window.modalStateObservable.isRelayModalActive = v;
      },
    },
  },
  watch: {
    /**
     * @param {boolean} isActive
     */
    isModalActive(isActive) {
      if (isActive && (this.search || '').length > 0) {
        this.getPickup();
      }
    },
    /**
     * @param {string} value
     */
    address(value) {
      this.search = value;
    },
  },
  methods: {
    /**
     * @param {Object} relay
     */
    relayClicked(relay) {
      this.activeRelay = relay;
      this.$emit('relayClicked', relay);
    },
    /**
     * @param {string} id
     */
    markerClicked({ id }) {
      this.relayClicked(this.findRelay(id));
    },
    /**
     * @param {string} id
     */
    findRelay(id) {
      return this.relayArray.find(({ pudo_id }) => pudo_id === id);
    },
    /**
     *
     * @param {Object} relay
     * @returns {boolean}
     */
    isCurrentRelay(relay) {
      return this.activeRelay === relay;
    },
    getPickup() {
      this.relayArray = relayPlaceholders;

      axios
        .post('/api/pickup', {
          search: this.search,
        })
        .then(response => {
          this.relayArray = response.data;
          this.activeRelay = this.currentRelay
            ? this.findRelay(this.currentRelay.id)
            : null;
        });
    },
    confirmRelaySelection() {
      this.isModalActive = false;
      this.$emit('relayConfirmed', this.activeRelay);
    },
    /**
     * @param {string} value
     */
    onAddressClick({ name, postcode, city }) {
      this.search = `${name} ${postcode} ${city}`;
      this.getPickup();
    },
  },
};
</script>
